/**
 * API Client — wraps Supabase client for backward compatibility.
 * Maintains { success, data } / { success: false, error } envelope
 * so existing screens don't need to change.
 */

import supabase from "../config/supabase";

class ApiClient {
  get supabase() {
    return supabase;
  }

  async getSession() {
    const { data } = await supabase.auth.getSession();
    return data?.session || null;
  }

  async getUserId() {
    const session = await this.getSession();
    return session?.user?.id || null;
  }

  async setTokens() {
    // No-op: Supabase manages tokens internally
  }

  async clearTokens() {
    await supabase.auth.signOut();
  }

  async getTokens() {
    const session = await this.getSession();
    if (!session) return null;
    return { access_token: session.access_token, refresh_token: session.refresh_token };
  }
}

const apiClient = new ApiClient();
export default apiClient;
